import { Capacitor, registerPlugin } from '@capacitor/core'

interface NativeFix extends FieldPosition {
  time?: number | null
}
interface NativeGps {
  addWatcher(
    options: {
      requestPermissions: boolean
      stale: boolean
      distanceFilter: number
      backgroundTitle?: string
      backgroundMessage?: string
    },
    callback: (fix?: NativeFix, error?: Error) => void
  ): Promise<string>
  removeWatcher(options: { id: string }): Promise<void>
}
export type ShiftFix = FieldPosition & {
  time: number
  shift: string
  worker: number
}
export const shiftNative = () => Capacitor.isNativePlatform()
export const shiftGps = registerPlugin<NativeGps>('BackgroundGeolocation')
const notifications = registerPlugin<{
  requestPermissions(): Promise<{ display: string }>
}>('LocalNotifications')

export async function shiftStartFix(): Promise<FieldPosition> {
  if (!shiftNative()) return getPosition(15000)
  if (Capacitor.getPlatform() === 'android')
    await notifications.requestPermissions()
  let release: (() => void) | undefined
  let done = false
  let timer: number
  try {
    return await new Promise<FieldPosition>((resolve, reject) => {
      timer = window.setTimeout(
        () =>
          reject(
            new Error(
              'GPS timed out. Check location permissions and try again outside.'
            )
          ),
        25000
      )
      shiftGps
        .addWatcher(
          { requestPermissions: true, stale: false, distanceFilter: 0 },
          (point, err) => {
            if (err) reject(err)
            else if (point) resolve(point)
          }
        )
        .then((id) => {
          release = () => {
            void shiftGps.removeWatcher({ id }).catch(() => {})
          }
          if (done) release()
        }, reject)
    })
  } finally {
    done = true
    clearTimeout(timer!)
    release?.()
  }
}
